var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editor',_vm._g(_vm._b({attrs:{"init":_vm.config}},'editor',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }